import { cn } from "@/lib/utils";
import { motion } from "@/lib/motion";
import { ReactNode, forwardRef } from "react";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { useMobileOptimizedMotion } from "@/hooks/useMobileOptimizedMotion";

interface OptimizedGlassCardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  delay?: number;
}

export const OptimizedGlassCard = forwardRef<HTMLDivElement, OptimizedGlassCardProps>(
  ({ children, className, hover = true, delay = 0 }, ref) => {
    const isMobile = useIsMobile();
    const { duration, enableHover, reduceDelay, viewport } = useMobileOptimizedMotion();
    
    return (
      <motion.div
        ref={ref}
        className={cn("group relative", className)}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={viewport}
        transition={{ 
          duration: 0.15,
          delay: 0
        }}
      >
        {/* Animated border gradient */}
        <div className="absolute inset-0 rounded-[var(--radius)] bg-gradient-to-br from-primary/20 via-accent/10 to-primary/20 opacity-50" style={{ padding: '1px' }}>
        </div>
        
        {/* Card content with lighter background */}
        <div className={cn(
          "relative glass-card rounded-[var(--radius)] p-8 md:p-10 h-full border border-foreground/10",
          "overflow-hidden",
          "backdrop-blur-sm"
        )}>
          
          <div className="relative z-10">
            {children}
          </div>
        </div>
      </motion.div>
    );
  }
);

OptimizedGlassCard.displayName = "OptimizedGlassCard";
